module.exports = __webpack_public_path__ + "img/Avatar-7.1897bbfb.svg";